import { getters } from '/@/modules/core/app/helpers/store';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export class EstateDistributionRouteConfig extends CurrentEstateRouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const authUser = getters.auth.getUser();
    if (authUser.currentEstate?.isStandardPlan) {
      return !authUser.currentEstate.paywall.hasStandardPlan;
    }

    return authUser.permission.canAccessEstateDistribution;
  }
}
